import { handleApiError } from "../../../Style";
import axiosInstance from "../../instance/AxiosInstance";

export const addAirportEffect = (airportData) => {
  return axiosInstance
    .post("/airports/insertairport", airportData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response?.data || { message: "Failed to add airport" };
    });
};

export const airportViewAllEffect = async () => {
  try {
    const response = await axiosInstance.get(`/airports/list`);

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch airport";
  }
};

export const fetchAirportsEffect = (action) => {
  const params = {};

  if (action.search) {
    params.pagination_required = true;
    params.pagesize = action.pagesize;
    params.pageNo = action.pageNo;
    params.search = action.search;
    params.approoved_status = action.approoved_status;
    if (action.search_by && action.search_by.trim() !== "") {
      params.search_by = action.search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = action.pagesize;
    params.pageNo = action.pageNo;
    params.approoved_status = action.approoved_status;
  }

  return axiosInstance
    .get(`/airports/list`, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Error fetching airports";
      throw new Error(message);
    });
};

export const deleteAirportEffect = (airportId) => {
  return axiosInstance
    .delete(`/airports/deleteairport/${airportId}`)
    .then((response) => {
     
      return response.data; // Return the response
    })
    .catch((error) => {
      throw error.response?.data || { message: "Failed to delete airport" };
    });
};
export const updateAirportEffect = (airportId, airportData) => {
  return axiosInstance
    .put(`/airports/updateairport/${airportId}`, airportData)
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || { message: "Failed to update airport" };
    });
};
export const approveAirportEffect = async (payload) => {
  const { airport_id, staff_approve_status } = payload?.payload;
  try {
    const response = await axiosInstance.put(
      `/airports/approveairportupdate?airport_id=${airport_id}`,
      { staff_approve_status: staff_approve_status }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || "Failed to Approve Airport";
  }
};

export const airportViewEffect = async (payload) => {
  try {
    const response = await axiosInstance.get(
      `airports/getairport?airport_id=${payload}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error) || "Failed to Fetch Service";
  }
};
